
import TiwiMixin from '../mixins/TiwiMixin';

export default {
    mixins: [TiwiMixin],
    props: {

    },
    data() {
        return {
            tags: []
        }
    },
    mounted() {
        this.fetchTags();
    },
    methods: {
        fetchTags() {
            const self = this;

            this.api.post('/tax-query/find', { taxonomy: 'tags', pluck: false })
                .then((response) => {
                    if (response.data.success) {
                        self.updateTagCloud(response.data.terms);
                    }
                });
        },

        updateTagCloud(tags) {
            this.tags = this.tagCloud(tags);
        },

        tagCloud(array, options) {
            const defaultOptions = { randomize: true, numBuckets: 4, limit: 25 };

            // Merge the options with the defaults
            const opts = Object.assign(defaultOptions, options ?? {});

            // Limits the tag cloud displaying the most used ones
            if (opts.limit) {
                array = array.sort((a, b) => b.count - a.count).slice(0, opts.limit);
            }

            // Get the min, max, and difference between them
            const counts = array.map(i => i.count), min = Math.min(...counts), max = Math.max(...counts), diff = (max - min),
                // Split the number of tags into the buckets as evenly as possible
                numTagsPerBucket = (diff || 1) / (opts.numBuckets - 1);

            const tags = array.map(tag => ({ bucket: Math.floor((tag.count - min) / numTagsPerBucket), ...tag }));

            // Shuffle the elements in the array to pseudo-randomize the tagCloud ordering
            if (opts.randomize) {
                return tags.sort(() => 0.5 - Math.random());
            }

            return tags;
        }
    },
}
